import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { ONBOARDING_EXPERIENCES } from '../../constants/onboarding-state/onboarding-constants.ts';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql.ts';

export const preloadNthUserOnboardingCompletedTimestamp = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [ONBOARDING_EXPERIENCES.NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP],
		},
	});
};
